import { render } from "./DashboardResources.vue?vue&type=template&id=6e8bf46b"
import script from "./DashboardResources.vue?vue&type=script&lang=js"
export * from "./DashboardResources.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/donorsweb/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__